import type * as React from 'react';

import { Head } from '@xing-com/crate-career-hub-common';
import { LoggedOutFooter } from '@xing-com/crate-career-hub-logged-out-footer';
import { GridContainer, GridItem } from '@xing-com/grid';
import { Section } from '@xing-com/layout-primitives';

import { HeaderNavigation } from './header-navigation';
import { MainPageHeader } from './main-page-header';
import { TopicList } from './topic-list';

export const KarriereMainEntry: React.FC = () => (
  <Section noBlockPadding>
    <Head />
    <GridContainer variant="FullSize">
      <GridItem span={12}>
        <HeaderNavigation />
        <MainPageHeader />
        <TopicList />
      </GridItem>
      <GridItem span={12}>
        <LoggedOutFooter />
      </GridItem>
    </GridContainer>
  </Section>
);
